import React from 'react';
import { Modal, Space, Input, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import SegmentedToggle from '../SegmentedToggle';

const { Text } = Typography;
const { TextArea } = Input;

const METHOD_OPTIONS = [
    { value: 'GET', text: 'GET' },
    { value: 'POST', text: 'POST' },
];

const WebPageModal = ({
    open,
    url,
    method = 'GET',
    jsonBody = '',
    loading,
    onUrlChange,
    onMethodChange,
    onJsonBodyChange,
    onCancel,
    onSubmit,
}) => (
    <Modal
        title={<Space><LinkOutlined style={{ color: 'var(--color-primary)' }} /><span>Add Web Page to Collection</span></Space>}
        open={open}
        onCancel={onCancel}
        onOk={onSubmit}
        confirmLoading={loading}
        okText="Add Web Page"
        width={600}
    >
        <div className="modal-form">
            <div className="form-item">
                <Text strong>HTTP method</Text>
                <div style={{ marginTop: 6 }}>
                    <SegmentedToggle
                        options={METHOD_OPTIONS}
                        value={method}
                        onChange={onMethodChange}
                    />
                </div>
            </div>
            <div className="form-item" style={{ marginTop: 16 }}>
                <Text strong>URL *</Text>
                <Input
                    placeholder="https://example.com/article"
                    value={url}
                    onChange={e => onUrlChange(e.target.value)}
                    size="large"
                    style={{ marginTop: 6 }}
                    onPressEnter={onSubmit}
                />
                <Text type="secondary" style={{ fontSize: 12, marginTop: 4, display: 'block' }}>
                    {method === 'POST'
                        ? 'HTML pages become Markdown; JSON responses are stored as compact TOON for better search.'
                        : 'HTML pages become Markdown; JSON API responses use compact TOON. Refresh later for updated content.'}
                </Text>
            </div>
            {method === 'POST' && (
                <div className="form-item" style={{ marginTop: 16 }}>
                    <Text strong>JSON body</Text>
                    <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>(optional)</Text>
                    <TextArea
                        placeholder={'{\n  "key": "value"\n}'}
                        value={jsonBody}
                        onChange={e => onJsonBodyChange(e.target.value)}
                        rows={6}
                        style={{ marginTop: 6, fontFamily: 'monospace' }}
                    />
                </div>
            )}
        </div>
    </Modal>
);

export default WebPageModal;
